import { render } from "./Pmprb.vue?vue&type=template&id=f818b304"
import script from "./Pmprb.vue?vue&type=script&lang=js"
export * from "./Pmprb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__